const updates = [
  {
    date: '2026-07-31',
    tag: '新站收录',
    title: '樱桃视频全新改版上线，界面更清爽观看体验全面升级',
  },
  {
    date: '2026-07-30',
    tag: '片源更新',
    title: '糖心视频本周热门短剧合集已同步，共收录热门短剧42部',
  },
  {
    date: '2026-07-29',
    tag: '平台公告',
    title: '红桃视频电视剧频道新增高清专区，超清画质免费观看',
  },
  {
    date: '2026-07-28',
    tag: '片源更新',
    title: '茄子视频最新综艺节目专题页上线，热门综艺一网打尽',
  },
  {
    date: '2026-07-27',
    tag: '站点优化',
    title: '桔子视频播放器全面升级，加载速度提升40%观看不缓冲',
  },
  {
    date: '2026-07-26',
    tag: '内容推荐',
    title: '本周必看推荐：五大平台热播剧集盘点，高分好剧别错过',
  },
  {
    date: '2026-07-25',
    tag: '新站收录',
    title: '新增合作视频站点接入，片源覆盖量突破20万+部作品',
  },
  {
    date: '2026-07-24',
    tag: '片源更新',
    title: '红桃视频、樱桃视频同步更新8月新片预告，抢先了解热门内容',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            热门快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            每日同步全网视频平台最新动态与片源更新，精彩内容不再错过
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative pb-8 last:pb-0 ${
                  i === 0 ? 'animate-in fade-in slide-in-from-bottom-2' : ''
                }`}
                style={{ animationDelay: `${i * 80}ms`, animationFillMode: 'both' }}
              >
                <div className="absolute -left-[41px] top-0 w-[18px] h-[18px] rounded-full border-[3px] border-primary-500 bg-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-1.5">
                  <span className="text-xs font-semibold text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full whitespace-nowrap w-fit">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 leading-relaxed">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}